module.exports = "pegasus/assets/blocks/column-5-theme5.png";